import { Box, CircularProgress, IconButton } from '@mui/material'
import React, { useState } from 'react'
import {
  aliasDisplayEmail,
  isAliasDisabled,
  type Alias as AliasData
} from '../../api/types'
import { DisabledAliasIcon, EditAliasIcon } from '../../icons'
import { Address } from '../address/address'
import { AliasEdit } from '../aliasEdit'
import { RemoveAliasButton, MoveAliasButton } from './group.actionButtons'

interface GroupItemAliasProps {
  alias: AliasData
  search?: string
  deletingAlias?: string
  onDeleteAlias: (alias: string) => void
  onAliasUpdated: (alias: AliasData) => void
  onToggleAlias: (alias: AliasData) => void
}

export const Alias: React.FC<GroupItemAliasProps> = ({
  alias,
  search = '',
  deletingAlias,
  onDeleteAlias,
  onAliasUpdated,
  onToggleAlias
}) => {
  const [editOpen, setEditOpen] = useState(false)
  const isDeleting = deletingAlias === alias.alias
  const isDisabled = isAliasDisabled(alias.alias)
  const displayEmail = aliasDisplayEmail(alias.alias)

  return (
    <>
      <tr style={{ opacity: isDisabled && !isDeleting ? 0.55 : 1 }}>
        <td>
          {isDeleting ? (
            <Box
              sx={{ color: 'text.disabled', textDecoration: 'line-through' }}
            >
              <Address value={displayEmail} search={search} />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {isDisabled && (
                <DisabledAliasIcon
                  sx={{ fontSize: '0.85rem', color: 'text.disabled' }}
                />
              )}
              <Address value={displayEmail} search={search} />
            </Box>
          )}
        </td>
        <td>
          <IconButton
            size="small"
            onClick={() => {
              setEditOpen(true)
            }}
            disabled={isDeleting}
          >
            <EditAliasIcon fontSize="small" />
          </IconButton>
        </td>
        <td>
          <MoveAliasButton alias={alias.alias} />
        </td>
        <td>
          <IconButton
            size="small"
            onClick={() => {
              onToggleAlias(alias)
            }}
            disabled={isDeleting}
            title={isDisabled ? 'Enable' : 'Disable'}
          >
            <DisabledAliasIcon
              fontSize="small"
              sx={{ color: isDisabled ? 'success.main' : 'text.secondary' }}
            />
          </IconButton>
        </td>
        <td>
          {isDeleting ? (
            <div style={{ width: 24, height: 24, margin: 8 }}>
              <CircularProgress size={24} />
            </div>
          ) : (
            <RemoveAliasButton
              selected={isDeleting}
              onClick={() => {
                onDeleteAlias(alias.alias)
              }}
            />
          )}
        </td>
      </tr>
      {editOpen && (
        <AliasEdit
          alias={alias}
          open={editOpen}
          onClose={() => {
            setEditOpen(false)
          }}
          onSaved={(updated) => {
            setEditOpen(false)
            onAliasUpdated(updated)
          }}
        />
      )}
    </>
  )
}
